/**
 * 音频工具类
 */
import { config } from '@/config/env';

/**
 * 获取完整的音频文件URL
 * @param {string} pronunciationUrl - 数据库中的发音URL
 * @returns {string} 完整的音频文件URL
 */
export function getFullAudioUrl(pronunciationUrl) {
  if (!pronunciationUrl) {
    return null;
  }
  
  // 如果已经是完整URL，直接返回
  if (pronunciationUrl.startsWith('http://') || pronunciationUrl.startsWith('https://')) {
    return pronunciationUrl;
  }
  
  // 拼接基础URL和发音URL
  return config.VOICE_URL + pronunciationUrl;
}

/**
 * 播放音频文件
 * @param {string} pronunciationUrl - 数据库中的发音URL
 * @returns {Promise} 播放Promise
 */
export function playAudio(pronunciationUrl) {
  const fullUrl = getFullAudioUrl(pronunciationUrl);
  
  if (!fullUrl) {
    return Promise.reject(new Error('暂无发音文件'));
  }
  
  const audio = new Audio(fullUrl);
  return audio.play();
}

export default {
  getFullAudioUrl,
  playAudio
};
